import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface Toast {
  type: 'success' | 'error';
  message: string;
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {
   private toastSubject = new BehaviorSubject<Toast | null>(null);
  toast$ = this.toastSubject.asObservable();

  showSuccess(message: string) {
    this.toastSubject.next({ type: 'success', message });
    this.autoHide();
  }

  showError(message: string) {
    this.toastSubject.next({ type: 'error', message });
    this.autoHide();
  }

  private autoHide() {
    setTimeout(() => {
      this.toastSubject.next(null);
    }, 4000); // hides after 3 seconds
  }
}
